var _circle, _path, _rect, _path2, _path3, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea3e05c3-7cbe-433b-9532-956d951aa84c",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.62 241.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.81,
    cy: 120.81,
    r: 120.81,
    fill: "#d5ff5d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M858.19,237.4l15.34-35.1,3.38-7.74-68,14a10.68,10.68,0,0,0-7.64,6.2l-5.81,13.28-36.93,7.62a10.73,10.73,0,0,0-7.65,6.2l-16.5,37.77L807.8,264.5l8-18.36,28-5.79Z",
    transform: "translate(-705.59 -143.69)",
    fill: "#1f73ed"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 855.03,
    y: 183.96,
    width: 8,
    height: 161.55,
    rx: 4,
    ry: 4,
    transform: "translate(834.99 707.14) rotate(-156.43)",
    fill: "#201c50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M826.16,309.64h.24l-12.87,29.52c-21.5-1.68-37.37-7.55-37.37-14.52C776.16,316.36,798.54,309.64,826.16,309.64Z",
    transform: "translate(-705.59 -143.69)",
    fill: "#201c50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M835,309.88c23.39,1.26,41.14,7.38,41.14,14.76,0,8.28-22.39,15-50,15-1.38,0-2.74,0-4.09-.05Z",
    transform: "translate(-705.59 -143.69)",
    fill: "#201c50"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 108.85 102.21 120.81 110.24 102.39 79.13 108.85",
    fill: "#201c50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1a0a2032657acbc4e810047787ca4aff.svg";
export { ForwardRef as ReactComponent };